import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adaptive-placement-test',
  templateUrl: './adaptive-placement-test.component.html',
  styleUrls: ['./adaptive-placement-test.component.scss']
})
export class AdaptivePlacementTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
